import styled, { css } from 'styled-components';
import { combineValues, globalTheme } from '@cld/component-theme';
import { ReactSliderProps } from '../ReactSlider';
import { sliderTheme } from '../sliderTheme';

const Track = styled.div<ReactSliderProps & { selected?: boolean }>`
  height: ${sliderTheme.normal.height};
  position: relative;

  &::after {
    content: '';
    height: ${sliderTheme.normal.track.height};
    width: 100%;
    ${({ selected }) =>
      selected &&
      css`
        background-color: ${combineValues(
          ({ disabled }) => !!disabled,
          globalTheme.palette.primary,
          globalTheme.palette.secondary,
          (disabled, sliderColor, disabledColor) => (disabled ? disabledColor : sliderColor)
        )};
      `};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
`;

export default Track;
